<template>

    <FloatingPanel>

        <div class="canvas-blocks-sky-contentBlog-BlockPanel">

            <CommonInputs
                :options="options"/>

            <SwitchInput label="Toon gebruiker"
                         instruction="Kies hier om de gebruiker te tonen."
                         :items="[
                             { value: 1, label: 'Aan'},
                             { value: 0, label: 'Uit'},
                         ]"
                         :options="options"
                         options-property="user_switch"
                         :defaultValue="1"
                         @valueChange="save()"/>

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        SwitchInput,
    },

}

</script>

<style lang="scss" scoped>

.canvas-blocks-sky-contentBlog-BlockPanel {

}

</style>
